import * as fromProducers from "./producer/producer.reducer";
import * as fromProducts from "./product/product.reducer";

export const reducers = {
  producers: fromProducers.ProducerReducer,
  products: fromProducts.ProductReducer,
};
